export enum MobilePostMessageName {
    NavigateBack = 'NavigateBack',
    SetClassroomUserIdSuccess = 'SetClassroomUserIdSuccess',
}
